<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :tree-config="treeConfig"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:areaHeader="{}">
        <el-dropdown trigger="click" :hide-on-click="false">
          <span class="el-dropdown-link">
            {{$l('btn_region') || '区域'}}<i
              class="el-icon-arrow-down el-icon--right"
              style="font-weight:bold;"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown" style="padding:10px;">
            <ul class="infinite-list">
              <li
                v-for="(itme, i) in areaList"
                :key="i"
                class="infinite-list-item"
              >
                <el-checkbox v-model="areas" :label="itme.label">{{
                  itme.label
                }}</el-checkbox>
              </li>
            </ul>
            <div class="mt-2" style="text-align:center">
              <el-button size="small" type="warning" @click="areaReset()"
                >{{ $l('INDEX.btn_reset') || '重置' }}</el-button
              >
              <el-button size="small" type="primary" @click="query()"
                >{{ $l('btn_filter') || '筛选' }}</el-button
              >
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <template v-slot:status="{row}">
        <el-tag
          size="mini"
          :type="row.yarnStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.yarnStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{row}">
        <div>
          <el-button
            type="text"
            size="mini"
            @click="
              openEditPage({
                pageType: 'edit',
                params: {yarnCode: row.yarnCode},
              })
            "
            v-if="allow('M')"
            >{{$l('INDEX.btn_tips_edit') || '编辑'}}</el-button
          >
          <el-button
            :disabled="row.yarnStatus === 'N'"
            type="text"
            size="mini"
            @click="del(row.yarnCode)"
            v-if="allow('D')"
            >{{$l('INDEX.btn_tips_del') || '删除'}}</el-button
          >
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
//import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      type: Object,
      default: () => {},
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      treeConfig: {},
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      //tableColumns: tableColumns(),
      tableColumns:[
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          width: 100,
          slots: {
            default: 'opt',
          },
        },
        {
          field: 'yarnNo',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_yarn_no') || '纱线编号',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'yarnName',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_yarn_name') || '纱线名称',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'yarnNameEn',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_yarn_name_en') || '纱线名称英文',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'yarnContent',
          align: 'center',
          minWidth: 175,
          title: this.$l('table_label_yarn_content') || '纱线成分中文',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'yarnContentEn',
          align: 'center',
          minWidth: 175,
          title: this.$l('table_label_yarn_content_en') || '纱线成分英文',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'categoryCode',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_category_code') || '分类名称',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'supName',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_sup_name') || '供应商名称',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'yarnCount',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_yarn_count') || '支数',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'spinningProcessName',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_spinning_process_name') || '纺纱工艺',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'dyeingProcessName',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_dyeing_process_name') || '染色工艺',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'spinningDate',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_spinning_date') || '纺纱时间',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'kgPrice',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_kg_price') || '单价',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'yarnUnit',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_yarn_unit') || '单位',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'moq',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_moq') || '起订量',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'yarnStatus',
          align: 'center',
          width: 150,
          title: this.$l('table_label_status') || '有效状态',
          slots: {default: 'status'},
          filters: [
            {label: '有效', value: 'Y'},
            {label: '无效', value: 'N'},
          ],
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
      ]

    }
  },
  methods: {
    del(code) {
      this.$confirm(this.$l('INDEX.tips_delete') ||'确认要删除该记录吗？', this.$l('INDEX.label_completeDesc') || '确认信息', {
          confirmButtonText:
          this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: 'warning',
        }).then(() => {
        this.$api.masterYarnDelApi({yarnCode: code}).then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },

    openEditPage({pageType, params}) {
      this.$router.push({
        name: 'master-yarn-detail',
        params: {...params, pageType},
      })
    },
  },
}
</script>
